/*eslint-disable */
import React, { Component } from "react";
import { Table, Grid, Icon, Button } from "semantic-ui-react";
import RateChartModal from "./rateChartModal";
import VendorBranchEdit from "../common/branchEdit";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import Name from "./name";
import { translate } from "react-i18next";
import BranchDeleteModal from "./branchDeleteModal";
import EditRateChart from "../common/rateChartEdit";
import DeleteAxios from "../axiosComponent/delete";
import BranchDetailModal from "./branchdetailmodal";
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
import ImportModal from "../titleBar/importModal";
export class BranchTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vendorRateChart: [],
      deleteModalOpen: false,
      ratechart: false,
      edit: {},
      deleteId:null,
      importModalOpen : false
    };
  }

  componentDidMount() {
  }

  setDeafultValue = (masterRoute, deafultValue) => {
    console.log("search dropdown >>>>", deafultValue);
    ReadAxios({
      url: `${masterRoute}/${deafultValue}`,
    })
      .then((res) => {
        console.log(res.data.resultSet);
      })
      .catch((err) => console.log(err));
  };

  BranchEditModal = (e, data) => {
    console.log(data);
    if (data.add_mode === 'add') {
      this.setState({
        branchmodal: true,
        editUserInputs: false,
        edit: null,
      })
    } else if (data.add_mode === 'edit') {
      this.setState({
        branchmodal: true,
        editUserInputs: true,
        edit: { ...data.user_items },
      })
    } else {
      this.setState({
        deleteModalOpen: true,
        edit: { ...data.user_items },
      })
    }
  };

  BranchModalClose = () => {
    this.setState({ branchmodal: false });
    window.location.reload();
  };
  openDeleteModal = (e, data) => {
    console.log("yes");
    this.setState({ deleteModalOpen: true, deleteId: { ...data.user_items } });
  };
  closeDeleteModal = () => {
    this.setState({ deleteModalOpen: false });
  };

  getcities = (id) => {
    console.log(id);
    ReadAxios({ url: `cityMaster/${id}` })
      .then((res) => {
        console.log('res', res.data.resultSet[0].cityName);
        let city = res.data.resultSet[0].cityName;
        return city;
      })
      .catch((err) => {
        return "NA";
      });
  }

  confirmDelete = async(e, data) => {
    console.log("delete row");
    await DeleteAxios({
      url: `vendorBranch`,
      uniqueId:this.state.deleteId.vendorBranchId
    })
      .then((res) => {
        let alert = {
          type: "success",
          messageHeader: "Success",
          messageBody: "Vendor branch deleted.",
        };
        console.log({res});
        this.props.successAlertDispatcher(alert);
        this.closeDeleteModal();
        window.location.reload();
      })
      .catch((err) => {
        console.log({err});
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: "Unable to delete vendor branch.",
        };
        // console.log(err);
        this.props.errorAlertDispatcher(alert);
        this.closeDeleteModal();
      });
  };

  handleImportOpen = ()=>{
    this.setState({importModalOpen : true})
  }

  handleImportClose = ()=>{
    window.location.reload()
  }

  updatePage = () => {
    console.log('this is called');
    this.BranchModalClose();
    window.location.reload();
  };

  render() {
    const { t } = this.props;
    return (
      <>
        {true && (
          <div>
            <Table stackable size="small" selectable>
              <Table.Header className="w3-small">
                <Table.Row>
                  <Table.HeaderCell colSpan="6" className="p-bold-600">
                    {t('title')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-600" textAlign="right">
                  <button
                    type="button"
                    onClick={() => this.handleImportOpen()}
                    className="grey-btn">
                    <i class="fas fa-file-import mr-1"></i>
                    {"Import"}
                  </button>

                    <Button
                      type="button"
                      className="w3-button w3-blue w3-small w3-round w3-hover-blue"
                      add_mode="add"
                      onClick={this.BranchEditModal}
                    >
                      <Icon name="plus" /> {t('add_title')}
                    </Button>
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className="p-bold-500" colSpan="1">
                    {t("table_header.branch")}
                  </Table.HeaderCell>
                  {/* <Table.HeaderCell className="p-bold-500">
                    {t("table_header.state")}
                  </Table.HeaderCell> */}
                  {/* <Table.HeaderCell className="p-bold-500">
                    {t("table_header.pan_number")}
                  </Table.HeaderCell> */}
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.gst_number")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.address")}
                  </Table.HeaderCell>
                  {/* <Table.HeaderCell className="p-bold-500">
                    {t("table_header.city")}
                  </Table.HeaderCell> */}
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.pincode")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.more_detail")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t('table_header.edit') || 'Edit'}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                      {t('table_header.delete') || 'Delete'}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              {this.props.BranchList && this.props.BranchList.length > 0 ? (
                this.props.BranchList.map((object, index) => (
                  <Table.Row key={index}>
                    <Table.Cell className="fixedLength150">{object.vendorBranchName ? object.vendorBranchName : "NA"}</Table.Cell>
                    {/* <Table.Cell>{object.vendorBranchStateId ? object.vendorBranchStateId : "NA"}</Table.Cell> */}
                    {/* <Table.Cell>{object.vendorBranchPAN ? object.vendorBranchPAN : "NA"}</Table.Cell> */}
                    <Table.Cell>{object.vendorBranchGST ? object.vendorBranchGST : "NA"}</Table.Cell>
                    <Table.Cell className="fixedLength150">{object.vendorBranchAddress ? object.vendorBranchAddress : "NA"}</Table.Cell>
                    {/* <Table.Cell>{object.vendorBranchCity ? this.getcities(object.vendorBranchCity) : "NA"}</Table.Cell> */}
                    <Table.Cell>{object.vendorBranchPincode ? object.vendorBranchPincode : "NA"}</Table.Cell>
                    <Table.Cell><BranchDetailModal id={object.vendorBranchId} data={object} cityNameField={"vendorBranchCityId"} /></Table.Cell>
                    <Table.Cell><Button user_items={object} type="button" add_mode="edit" onClick={this.BranchEditModal} size="mini" color="green" basic icon> <Icon name="edit" /> </Button> </Table.Cell>
                  <Table.Cell><Button type="button"  user_items={object} add_mode="delete" onClick={this.openDeleteModal} size="mini" color="blue" basic icon> <Icon name="trash" /> </Button></Table.Cell>
                  </Table.Row>
                ))
              ) : (
                <Table.Row>
                  <Table.Cell colSpan="6">{t("records" || "No Record(s) Found")}</Table.Cell>
                </Table.Row>
              )}
            </Table>
          </div>
        )}
        <BranchDeleteModal
          branchId={this.state.deleteId}
          deleteOpen={this.state.deleteModalOpen}
          CloseModal={this.closeDeleteModal}
          ConfirmDeleteRow={this.confirmDelete}
        />
        <VendorBranchEdit
          vendorId={this.props.vendorId}
          branchModal={this.state.branchmodal}
          CloseModal={this.BranchModalClose}
          vendor_code={this.props.vendor_code}
          editData={this.state.edit}
          onFormSubmit={this.updatePage}
        />
         <ImportModal
        openBox={this.state.importModalOpen}
        handleClose={this.handleImportClose}
        fileName={this.props.fileName}
        baseURL={this.props.importBaseUrl}
        masterIdName={this.props.masterIdName || null}
        masterIdValue={this.props.masterIdValue || null}
        />
      </>
    );
  }
}

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate('branch')(BranchTable));
